// extracted by mini-css-extract-plugin
export default {"content":"ErrorContent_content__OLwH+"};